import { render, staticRenderFns } from "./ReportVisitHistories.vue?vue&type=template&id=5987e616&"
import script from "./ReportVisitHistories.vue?vue&type=script&lang=js&"
export * from "./ReportVisitHistories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports